import React, { useEffect, useState } from "react";
import { Loader } from "react-overlay-loader";
import { DatePicker, Button, Col, Row, Select, Modal } from "antd";
import Datatable from "../../component/table/dataTable";
import request from "../../lib/requester";
import moment from "moment";
import formatCurency from "../../component/format/formatCurency";
import xlsx from "xlsx";
const { Option } = Select;

const ReportRpaReceipt = () => {
  const [isLoading, setIsloading] = useState(false);
  const [data, setData] = useState([]);
  const [dataDownload, setDataDownload] = useState([]);
  const [listPPh, setListPPh] = useState([]);
  const [listPrincipal, setListPrincipal] = useState([]);
  const [listBranch, setListBranch] = useState([]);

  const [principal, setPrincipal] = useState(null);
  const [uploadByPrincipl, setUploadByPrincipal] = useState(null);
  const [uplaodDate, setUploadDate] = useState("");
  const [branch, setBranch] = useState(null);
  const [pphType, setPphType] = useState(0);
  const [awbToPrincipal, setAwbToPrincipal] = useState(null);

  useEffect(() => {
    getPphType();
    getPrincipal();
    getBranch();
  }, []);

  const search = async () => {
    if (uplaodDate) {
      setIsloading(true);
      let url = `/api/traces/v1/report/rpa?${principal ? `principal=${principal}&` : ""
        }${branch ? `branch=${branch}&` : ""}${uploadByPrincipl ? `uploadBy=${uploadByPrincipl}&` : ""
        }${uplaodDate ? `uploadDate=${uplaodDate}&` : ""}${awbToPrincipal ? `awb_principal_submit_dt=${awbToPrincipal}&` : ""
        }${pphType ? `pphType=${pphType}&` : ""}`;

      await request.getTraces(url, {
        success: function (response) {
          const res = response.data.data;
          const maping = res
            ? res.map((value) => {
              return {
                PRINCIPAL_CODE: value.PRINCIPAL_CODE,
                UPLOAD_BUPOT_BY_PRINCIPAL: value.UPLOAD_BUKPOT_BY_PRINCIPAL,
                CLAIM_NUMBER: value.CLAIM_NUMBER,
                BRANCH: value.BRANCH,
                CUSTOMER_NAME: value.CUSTOMER_NAME,
                PROGRAM_TYPE: value.PROGRAM_TYPE,
                AWB_NO_CABANG_SUBMIT_DATE: value.AWB_NO_CABANG_SUBMIT_DATE
                  ? moment(value.AWB_NO_CABANG_SUBMIT_DATE).format(
                    "DD MMMM YYYY"
                  )
                  : value.AWB_NO_CABANG_SUBMIT_DATE,
                AWB_RECEIPT_DATE_HO: value.AWB_RECEIPT_DATE_HO
                  ? moment(value.AWB_RECEIPT_DATE_HO).format("DD MMMM YYYY")
                  : value.AWB_RECEIPT_DATE_HO,
                AR_INVOICE_NUMBER: value.AR_INVOICE_NUMBER,
                COVER_LETTER_NUMBER: value.COVER_LETTER_NUMBER,
                COVER_LETTER_DATE: value.COVER_LETTER_DATE
                  ? moment(value.COVER_LETTER_DATE).format("DD MMMM YYYY")
                  : value.COVER_LETTER_DATE,
                AWB_HO_SUBMIT_TO_PRINCIPAL: value.AWB_HO_SUBMIT_TO_PRINCIPAL
                  ? moment(value.AWB_HO_SUBMIT_TO_PRINCIPAL).format(
                    "DD MMMM YYYY"
                  )
                  : value.AWB_HO_SUBMIT_TO_PRINCIPAL,
                APPROVED_REJECTED_DATE: value.APPROVED_REJECTED_DATE
                  ? moment(value.APPROVED_REJECTED_DATE).format(
                    "DD MMMM YYYY"
                  )
                  : value.APPROVED_REJECTED_DATE,
                NILAI_DPP: formatCurency(value.NILAI_DPP),
                NILAI_PPN: formatCurency(value.NILAI_PPN),
                TOTAL_CLAIM: formatCurency(value.TOTAL_CLAIM),
                PPH_TYPE: value.PPH_TYPE,
                PPH_RATE: value.PPH_RATE,
                NILAI_PPH: formatCurency(value.NILAI_PPH),
                MASA_PAJAK: value.MASA_PAJAK,
                TAHUN_PAJAK: value.TAHUN_PAJAK,
                CLAIM_NET: formatCurency(value.CLAIM_NET),
                PAYMENT_DATE: value.PAYMENT_DATE
                  ? moment(value.PAYMENT_DATE).format("DD MMMM YYYY")
                  : value.PAYMENT_DATE,
                DUE_DATE_UPLOAD_BUPOT: value.DUE_DATE_UPLOAD_BUKPOT
                  ? moment(value.DUE_DATE_UPLOAD_BUKPOT).format(
                    "DD MMMM YYYY"
                  )
                  : value.DUE_DATE_UPLOAD_BUKPOT,
                RPA_DATE: value.RPA_DATE
                  ? moment(value.RPA_DATE).format("DD MMMM YYYY")
                  : value.RPA_DATE,
                RPA_FLAG: value.RPA_FLAG,
                RPA_NOTES: value.RPA_NOTES,
                UPLOAD_DATE_EBUPOT: value.UPLOAD_DATE_EBUKPOT
                  ? moment(value.UPLOAD_DATE_EBUKPOT).format("DD MMMM YYYY")
                  : value.UPLOAD_DATE_EBUKPOT,
                UPLOAD_FLAG: value.UPLOAD_FLAG,
                DOWNLOAD_BUPOT_DATE: value.DOWNLOAD_BUPOT_DATE
                  ? moment(value.DOWNLOAD_BUPOT_DATE).format("DD MMMM YYYY")
                  : value.DOWNLOAD_BUPOT_DATE,
                DOWNLOAD_REFUND_LETTER_DATE: value.DONWLOAD_REFUND_LETTER_DATE
                  ? moment(value.DONWLOAD_REFUND_LETTER_DATE).format(
                    "DD MMMM YYYY"
                  )
                  : value.DONWLOAD_REFUND_LETTER_DATE,
                DOWNLOAD_DOC_MANDATORY_DATE: value.DONWLOAD_DOC_MANDATORY_DATE
                  ? moment(value.DONWLOAD_DOC_MANDATORY_DATE).format(
                    "DD MMMM YYYY"
                  )
                  : value.DONWLOAD_DOC_MANDATORY_DATE,
                BUPOT_NUMBER: value.BUPOT_NUMBER,
                BUPOT_DATE: value.BUPOT_DATE
                  ? moment(value.BUPOT_DATE).format("DD MMMM YYYY")
                  : value.BUPOT_DATE,
              };
            })
            : [];
          setDataDownload(res)
          setIsloading(false);
          setData(maping);
        },
        error: function (e) {
          setIsloading(false);
        },
      });
    } else {
      warning();
    }
  };

  const getPphType = async () => {
    setIsloading(true);
    let url = "/api/traces/v1/general/pph-type";
    await request.getTraces(url, {
      success: function (response) {
        const res = response.data.data;
        setListPPh(res);
        setIsloading(false);
      },
      error: function (e) {
        setIsloading(false);
      },
    });
  };

  const getPrincipal = async () => {
    setIsloading(true);
    let url = "/api/traces/v1/general/list-principal";
    await request.getTraces(url, {
      success: function (response) {
        const res = response.data.data;
        setListPrincipal(res);
        setIsloading(false);
      },
      error: function (e) {
        setIsloading(false);
      },
    });
  };

  const getBranch = async () => {
    setIsloading(true);
    let url = "/api/traces/v1/general/list-cabang";
    await request.getTraces(url, {
      success: function (response) {
        const res = response.data.data;
        setListBranch(res);
        setIsloading(false);
      },
      error: function (e) {
        setIsloading(false);
      },
    });
  };

  const warning = () => {
    Modal.warning({
      title: "Failed",
      content: "Please select Date",
      onOk() {
        setData([]);
      },
    });
  };

  const downloadToXlsx = () => {
    const maping = dataDownload.map((value, index) => {
      return {
        PRINCIPAL_CODE: value.PRINCIPAL_CODE,
        UPLOAD_BUPOT_BY_PRINCIPAL: value.UPLOAD_BUKPOT_BY_PRINCIPAL,
        CLAIM_NUMBER: value.CLAIM_NUMBER,
        BRANCH: value.BRANCH,
        CUSTOMER_NAME: value.CUSTOMER_NAME,
        PROGRAM_TYPE: value.PROGRAM_TYPE,
        AWB_NO_CABANG_SUBMIT_DATE: value.AWB_NO_CABANG_SUBMIT_DATE
          ? new Date(moment(value.AWB_NO_CABANG_SUBMIT_DATE).utc().format("DD MMM YYYY"))
          : value.AWB_NO_CABANG_SUBMIT_DATE,
        AWB_RECEIPT_DATE_HO: value.AWB_RECEIPT_DATE_HO
          ? new Date(moment(value.AWB_RECEIPT_DATE_HO).utc().format("DD MMM YYYY"))
          : value.AWB_RECEIPT_DATE_HO,
        AR_INVOICE_NUMBER: value.AR_INVOICE_NUMBER,
        COVER_LETTER_NUMBER: value.COVER_LETTER_NUMBER,
        COVER_LETTER_DATE: value.COVER_LETTER_DATE
          ? new Date(moment(value.COVER_LETTER_DATE).utc().format("DD MMM YYYY"))
          : value.COVER_LETTER_DATE,
        AWB_HO_SUBMIT_TO_PRINCIPAL: value.AWB_HO_SUBMIT_TO_PRINCIPAL
          ? new Date(moment(value.AWB_HO_SUBMIT_TO_PRINCIPAL).utc().format("DD MMM YYYY"))
          : value.AWB_HO_SUBMIT_TO_PRINCIPAL,
        APPROVED_REJECTED_DATE: value.APPROVED_REJECTED_DATE
          ? new Date(moment(value.APPROVED_REJECTED_DATE).utc().format("DD MMM YYYY"))
          : value.APPROVED_REJECTED_DATE,
        NILAI_DPP: value.NILAI_DPP,
        NILAI_PPN: value.NILAI_PPN,
        TOTAL_CLAIM: value.TOTAL_CLAIM,
        PPH_TYPE: value.PPH_TYPE,
        PPH_RATE: value.PPH_RATE,
        NILAI_PPH: value.NILAI_PPH,
        MASA_PAJAK: value.MASA_PAJAK,
        TAHUN_PAJAK: value.TAHUN_PAJAK,
        CLAIM_NET: value.CLAIM_NET,
        PAYMENT_DATE: value.PAYMENT_DATE
          ? new Date(moment(value.PAYMENT_DATE).utc().format("DD MMM YYYY"))
          : value.PAYMENT_DATE,
        DUE_DATE_UPLOAD_BUPOT: value.DUE_DATE_UPLOAD_BUKPOT
          ? new Date(moment(value.DUE_DATE_UPLOAD_BUKPOT).utc().format("DD MMM YYYY"))
          : value.DUE_DATE_UPLOAD_BUKPOT,
        RPA_DATE: value.RPA_DATE ? new Date(moment(value.RPA_DATE).utc().format("DD MMM YYYY")) : value.RPA_DATE,
        RPA_FLAG: value.RPA_FLAG,
        RPA_NOTES: value.RPA_NOTES,
        UPLOAD_DATE_EBUPOT: value.UPLOAD_DATE_EBUKPOT
          ? new Date(moment(value.UPLOAD_DATE_EBUKPOT).utc().format("DD MMM YYYY"))
          : value.UPLOAD_DATE_EBUKPOT,
        UPLOAD_FLAG: value.UPLOAD_FLAG,
        DOWNLOAD_BUPOT_DATE: value.DOWNLOAD_BUPOT_DATE
          ? new Date(moment(value.DOWNLOAD_BUPOT_DATE).utc().format("DD MMM YYYY"))
          : value.DOWNLOAD_BUPOT_DATE,
        DOWNLOAD_REFUND_LETTER_DATE: value.DONWLOAD_REFUND_LETTER_DATE
          ? new Date(moment(value.DONWLOAD_REFUND_LETTER_DATE).utc().format("DD MMM YYYY"))
          : value.DONWLOAD_REFUND_LETTER_DATE,
        DOWNLOAD_DOC_MANDATORY_DATE: value.DONWLOAD_DOC_MANDATORY_DATE
          ? new Date(moment(value.DONWLOAD_DOC_MANDATORY_DATE).utc().format("DD MMM YYYY"))
          : value.DONWLOAD_DOC_MANDATORY_DATE,
        BUPOT_NUMBER: value.BUPOT_NUMBER,
        BUPOT_DATE: value.BUPOT_DATE
          ? new Date(moment(value.BUPOT_DATE).utc().format("DD MMM YYYY"))
          : value.BUPOT_DATE,
      };
    });

    const workBook = xlsx.utils.book_new();
    const workSheet = xlsx.utils.json_to_sheet(maping, {
      dateNF: "DD MMM YYYY",
      cellDates: true,
    });
    xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1");
    xlsx.writeFile(
      workBook,
      `report-rpa-receipt-bupot-${moment(new Date()).format(
        "DD-MMM-YYYY HHmmss"
      )}.xlsx`,
      { cellDates: true }
    );
  };

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="row ml-1">
            <div className="col-lg-12">
              <div className="card card-info">
                <div className="card-header">
                  Report RPA and Report Receipt E-Bupot
                </div>
                <div className="card-body">
                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Principal
                        </label>
                        <div className="col-md-12">
                          <Select
                            style={{ width: "100%" }}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            onChange={(e) => setPrincipal(e)}
                            value={principal}
                          // defaultValue={selectedChanel}
                          >
                            <Option value={null}>All Principal</Option>
                            {listPrincipal.map((value, index) => {
                              return (
                                <Option key={value.org_id} value={value.org_id}>
                                  {value.org_name}
                                </Option>
                              );
                            })}
                          </Select>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Uploaded by Principal
                        </label>
                        <div className="col-md-12">
                          <Select
                            style={{ width: "100%" }}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            onChange={(e) => setUploadByPrincipal(e)}
                            value={uploadByPrincipl}
                          >
                            <Option value={null}>All</Option>
                            <Option value={"YES"}>Yes</Option>
                            <Option value={"NO"}>No</Option>
                          </Select>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Upload Date
                        </label>
                        <div className="col-md-12">
                          <DatePicker
                            style={{ width: "100%" }}
                            disabledDate={false}
                            allowClear={true}
                            onChange={(value, dateStr) => {
                              setUploadDate(dateStr);
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Awb HO Submit To Principal
                        </label>
                        <div className="col-md-12">
                          <DatePicker
                            style={{ width: "100%" }}
                            disabledDate={false}
                            allowClear={true}
                            onChange={(value, dateStr) => {
                              setAwbToPrincipal(dateStr);
                            }}
                          />
                          {/* <Select
                            style={{ width: "100%" }}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            onChange={(e) => setAwbToPrincipal(e)}
                            value={awbToPrincipal}
                          >
                            <Option value={null}>All</Option>
                          </Select> */}
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          Branch
                        </label>
                        <div className="col-md-12">
                          <Select
                            style={{ width: "100%" }}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            onChange={(e) => setBranch(e)}
                            value={branch}
                          >
                            <Option value={null}>All Branch</Option>
                            {listBranch.map((value, index) => {
                              return (
                                <Option
                                  key={value.org_id}
                                  value={value.org_name}
                                >
                                  {value.org_name}{" "}
                                </Option>
                              );
                            })}
                          </Select>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label">
                          PPH Type
                        </label>
                        <div className="col-md-12">
                          <Select
                            style={{ width: "100%" }}
                            showSearch
                            placeholder="Search"
                            optionFilterProp="children"
                            onChange={(e) => setPphType(e)}
                            value={pphType}
                          >
                            <Option value={0}>All Type</Option>
                            {listPPh.map((value, index) => {
                              return (
                                <Option key={value.id} value={value.pph_type}>
                                  {value.pph_type}
                                </Option>
                              );
                            })}
                          </Select>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label className="col-md-12 col-form-label"></label>
                        <div className="col-md-12 mt-3">
                          <Button
                            onClick={() => search()}
                            type="primary"
                            className="btn-block w-100"
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={24}
                      style={{
                        display: `${data.length ? "flex" : "none"}`,
                        justifyContent: "end",
                        marginBottom: "-40px",
                      }}
                    >
                      <Button size="large" onClick={() => downloadToXlsx()} style={{ zIndex: 100 }}>
                        download
                      </Button>
                    </Col>
                    <Col md={24}>
                      <Datatable
                        data={data}
                        filterButton={true}
                        // download={data}
                        addTittle={"Report RPA"}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Loader fullPage loading={isLoading} />
    </div>
  );
};

export default ReportRpaReceipt;
